import { Component, EventEmitter, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
    selector: 'app-view-icon-button',
    templateUrl: './view-icon-button.component.html',
    standalone: false
})
export class ViewIconButtonComponent extends AppBaseComponent {
  @Output() triggered = new EventEmitter<void>();

  onClick(): void {
    this.triggered.emit();
  }
}
